module.exports = __webpack_public_path__ + "img/202304031325442665it.91e50ede.jpg";